import { CronExpressionParser } from "cron-parser";

/** Why a custom expression cannot be stored, or `undefined`. */
export function cronError(cron: string): string | undefined {
  const fields = cron.trim().split(/\s+/);
  if (cron.trim().length === 0) {
    return "Enter a cron expression.";
  }
  if (fields.length !== 5) {
    return "Expected five fields: minute hour day-of-month month day-of-week.";
  }
  try {
    CronExpressionParser.parse(cron.trim());
    return undefined;
  } catch (error) {
    return error instanceof Error ? error.message : "Invalid cron expression";
  }
}
